import React from "react";

import stateData from "./map_boundaries/stateData";
import countyData from "./map_boundaries/countyData";
import huc2Data from "./map_boundaries/huc2Data";
import huc4Data from "./map_boundaries/huc4Data";
import huc6Data from "./map_boundaries/huc6Data";
import huc8Data from "./map_boundaries/huc8Data";

import { ResolutionKeys } from "../types";

const map_geopolygon = {
  state: stateData,
  county: countyData,
  huc2: huc2Data,
  huc4: huc4Data,
  huc6: huc6Data,
  huc8: huc8Data,
  overlay: undefined
};

interface ExportTemplateProps {
  resolution: ResolutionKeys;
  is_overlay?: string;
  filename?: string;
}

const ExportTemplate: React.FC<ExportTemplateProps> = ({
  resolution,
  filename = "template.csv",
  is_overlay = "False",
}) => {
  const generateCSV = () => {
    // Create CSV header
    const header = "GEOID,NAME,VALUE\n";

    let data = map_geopolygon[resolution]

    if (is_overlay == "True" || data == undefined) return

    for (let i = 0; i < data.features.length; i++) {}

    // Convert data to CSV rows
    let csvRows;
    if (resolution === "county" || resolution === "state")
    {
      csvRows = data.features.map(feature => 
        `${feature.id},${feature.properties?.name},\n`
      );
    }else{
      csvRows = data.features.map(feature => 
        `${feature.id},${feature.properties?.huc_name},\n`
      );
    }

    // Combine header and rows
    const csvContent = header + csvRows.join("");

    // Create blob and download link
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");

    // Create download URL
    const url = window.URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);

    // Append link, trigger download, and cleanup
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  return (
    <button
      onClick={generateCSV}
      className="export-map-button"
      style={{margin: "0px"}}
      disabled={is_overlay == "True" ? true : false}
    >
      Download Template
    </button>
  );
};

export default ExportTemplate;
